import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'webform-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
})
export class DetailsComponent implements OnInit {
  @Output() onSubmit: EventEmitter<void> = new EventEmitter<void>();
  @Input() field!: any;
  @Input() parentGroup!: FormGroup;
  @Input() submit!: Function;
  expanded: boolean = false;

  id!: string;
  type!: string;
  box!: boolean;
  background!: string;

  ngOnInit(): void {
    this.id = this.field['#webform_id'];
  }

  /**
   * Get all the subfields of a container
   * @param container
   */
  getContainerSubfields(container: any): any[] {
    const containerSubfields: any[] = [];

    Object.keys(container).forEach((key: string) => {
      if (!key.includes('#')) containerSubfields.push(container[key]);
    });

    return containerSubfields;
  }

  toggleExpanded() {
    this.expanded = !this.expanded;
  }
}
